import { render } from "./EmployeesTable.vue?vue&type=template&id=eb482368"
import script from "./EmployeesTable.vue?vue&type=script&lang=js"
export * from "./EmployeesTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__